
import React from "react";
import axios from 'axios';
import {BrowserRouter,Routes,Route,createBrowserRouter,RouterProvider} from "react-router-dom";
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Provider }  from 'react-redux';



import {store} from './state/redux'; 
import { queryClient } from "./state/queryClient";

import Login from "./Pages/Login";
import Application  from "./Pages/Application";



function App() {
const router = createBrowserRouter([ { path: "/", element: <Application />,},
                                        { path: "/login", element: <Login />},
                                        {path: "*", element: <Application />}]);

                                        
  return (<React.StrictMode>
         <Provider store={store}>
              <QueryClientProvider client ={queryClient}>
                       <RouterProvider  future={{v7_relativeSplatPath: true,}} 
                                        router={router} />
                </QueryClientProvider> 
           </Provider></React.StrictMode>);
}

export default App;


